import React, { createContext, useContext } from 'react';
import type { 
  FilterBarState, 
} from '../../../types/components/filter_bar_types';
import { useFilterBar, UseFilterBarResult } from '../hooks/useFilterBar';

interface FilterBarContextType extends UseFilterBarResult {
  // Additional context-specific props if needed
}

const FilterBarContext = createContext<FilterBarContextType | undefined>(
  undefined,
);

export interface FilterBarProviderProps {
  children: React.ReactNode;
  state: FilterBarState;
}

export const FilterBarProvider: React.FC<FilterBarProviderProps> = ({
  children,
  state,
}) => {
  const filterBarResult = useFilterBar({ state });

  return (
    <FilterBarContext.Provider value={filterBarResult}>
      {children}
    </FilterBarContext.Provider>
  );
};

export const useFilterBarContext = () => {
  const context = useContext(FilterBarContext);
  if (context === undefined) {
    throw new Error(
      'useFilterBarContext must be used within a FilterBarProvider',
    );
  }
  return context;
};

export { FilterBarContext };
